import { getKeycloak } from "../keycloak";
import { clearLocalStorageOnSignOut } from "../components/upload/interruptedUpload";

const keycloak = getKeycloak();

export function authHeader() {
  // return authorization header with jwt token
  let token = localStorage.getItem("token");

  if (token) {
    return "Bearer " + token;
  } else {
    // A sign-out: everything goes but a message left for an account whose upload a dead
    // session cut short (AKL-891); see interruptedUpload.ts.
    clearLocalStorageOnSignOut();
    keycloak.logout({
      redirectUri: window.location.origin + "/login",
    });
  }
}
